// Code generated by Slice Machine. DO NOT EDIT.

import AccountPageBanner from './AccountPageBanner';
import Biography from './Biography';
import ContactUs from './ContactUs';
import Divider from './Divider';
import Faq from './Faq';
import FaqSection from './FaqSection';
import HeroSection from './HeroSection';
import ImageText from './ImageText';
import InstagramGrid from './InstagramGrid';
import KeyValuePair from './KeyValuePair';
import LatestRecipes from './LatestRecipes';
import List from './List';
import MediaKit from './MediaKit';
import Multimedia from './Multimedia';
import PressKitHeroSection from './PressKitHeroSection';
import PresskitNewsSection from './PresskitNewsSection';
import RefBanner from './RefBanner';
import RichText from './RichText';
import ShareToSocialMedia from './ShareToSocialMedia';

export {
	AccountPageBanner,
	Biography,
	ContactUs,
	Divider,
	Faq,
	FaqSection,
	HeroSection,
	ImageText,
	InstagramGrid,
	KeyValuePair,
	LatestRecipes,
	List,
	MediaKit,
	Multimedia,
	PressKitHeroSection,
	PresskitNewsSection,
	RefBanner,
	RichText,
	ShareToSocialMedia,
};

export const components = {
	account_page_banner: AccountPageBanner,
	review: Biography,
	contact_us: ContactUs,
	divider: Divider,
	faq: Faq,
	faq_section: FaqSection,
	hero_section: HeroSection,
	image_text: ImageText,
	instagram_grid: InstagramGrid,
	key_value_pair: KeyValuePair,
	latest_recipes: LatestRecipes,
	list: List,
	media_kit: MediaKit,
	video: Multimedia,
	press_kit_hero_section: PressKitHeroSection,
	presskit_news_section: PresskitNewsSection,
	ref_banner: RefBanner,
	rich_text: RichText,
	share_to_social_media: ShareToSocialMedia,
};
